<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="query-form">
      <el-form label-position="right" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <div style="display: flex">
                  <el-form-item label="买手店">
                    <!-- 保留vendorName -->
                    <!-- <el-select
                      v-model="queryForm.vendorIds"
                      multiple
                      filterable
                      clearable
                      collapse-tags
                    >
                      <el-option
                        v-for="item in vendorList"
                        :label="item.vendorName"
                        :value="item.vendorId"
                        :key="item.vendorId"
                      ></el-option>
                    </el-select> -->
                    <BrandSelect
                      v-model="queryForm.vendorIds"
                      :data="vendorList"
                      multiple
                      filterable
                      clearable
                      collapseTags
                    ></BrandSelect>
                  </el-form-item>
                  <div style="margin-left: 6px">
                    <el-button
                      @click="showBatchVendorForm"
                      style="width: 80px; background-color: #f5f7fa"
                      >批量</el-button
                    >
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item
                  label-width="110px"
                  :label="$t('crm.vendorRegion')"
                >
                  <el-select v-model="queryForm.businessRegionId" clearable>
                    <el-option
                      v-for="(item, idx) in businessRegionList"
                      :key="idx"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="结算状态">
                  <el-select v-model="queryForm.settlementStatus" clearable>
                    <el-option label="待付款" :value="1"></el-option>
                    <el-option label="已结算" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="申请日期">
                  <el-date-picker
                    v-model="daterange"
                    type="daterange"
                    value-format="timestamp"
                    :default-time="['00:00:00', '23:59:59']"
                    :picker-options="pickerOptions"
                    @blur="onDateBlur"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="结算日期">
                  <el-date-picker
                    v-model="settledDateRange"
                    type="daterange"
                    value-format="timestamp"
                    :default-time="['00:00:00', '23:59:59']"
                    :picker-options="pickerOptions"
                    @blur="onDateBlur"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="付款完成人" label-width="120px">
                  <el-input
                    placeholder="请输入"
                    v-model="queryForm.paymentCompletionOperator"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="结算单号">
                  <el-input
                    placeholder="请输入"
                    type="textarea"
                    rows="2"
                    v-model="queryForm.identifiersNos"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="是否异常">
                  <el-select v-model="queryForm.controversyStatus" clearable>
                    <el-option label="异常" :value="1"></el-option>
                    <el-option label="正常" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="toolbar">
      <div>
        <el-button
          type="primary"
          @click="batchSettled"
          :disabled="selection.length === 0"
          >付款完成</el-button
        >
        <el-button
          type="primary"
          @click="batchResendEmail"
          :disabled="selection.length === 0"
          >发送邮件</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-download"
          @click="exportData2"
          :loading="exporting2"
          >导出结算单</el-button
        >
        <span class="ml20" v-if="exportFileName2"
          >上一次导出结果：<el-link
            type="primary"
            @click="downloadExportResult2"
            >{{ exportFileName2 }}</el-link
          ></span
        >
        <span class="ml20 red" v-if="exportFailed2">导出失败</span>
      </div>
      <div>
        <!-- <el-button type="primary" icon="el-icon-printer" :disabled="!selection.length" @click="printPayrollRequisition">
          打印请款单
        </el-button> -->
        <el-button
          type="primary"
          icon="el-icon-printer"
          :disabled="!selection.length"
          @click="printFinalStatement"
        >
          打印结算单
        </el-button>
      </div>
      <div>
        <el-button
          type="primary"
          icon="el-icon-download"
          @click="exportData"
          :loading="exporting"
          >导出</el-button
        >
        <span class="ml20" v-if="exportFileName"
          >上一次导出结果：<el-link
            type="primary"
            @click="downloadExportResult"
            >{{ exportFileName }}</el-link
          ></span
        >
        <span class="ml20 red" v-if="exportFailed">导出失败</span>
      </div>
    </div>

    <el-table :data="tableData" @selection-change="handleSelectionChange">
      <!-- <el-table-column width="45">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.checked"></el-checkbox>
        </template>
      </el-table-column> -->
      <el-table-column :selectable="canSelect" type="selection" width="55"> </el-table-column>
      <el-table-column prop="settlementIdentifiersNo" label="结算单号">
        <template slot-scope="scope">
          <el-link type="primary" @click="showItem(scope.row)">{{
            scope.row.settlementIdentifiersNo
          }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="vendorName" label="店铺名称">
        <template slot-scope="scope">
          {{ scope.row.vendorName }}
          <div style="color: red">
            {{ scope.row.vendorControversyStatus === 1 ? "(店铺存在异常结算单)" :  ""  }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="businessRegionName"
        label="业务运营区域"
      ></el-table-column>
      <el-table-column prop="settlementStartTime" label="账期">
        <template slot-scope="scope">
          {{ scope.row.settlementStartTime }} -
          {{ scope.row.settlementEndTime }}
        </template>
      </el-table-column>
      <el-table-column prop="countOrders" label="结算单据数"></el-table-column>
      <el-table-column prop="countAmount" label="结算金额"></el-table-column>
      <el-table-column prop="paymentDescription" label="币种">
        <template slot-scope="scope">
          {{ scope.row.currency }}
        </template>
      </el-table-column>
      <el-table-column prop="settleRate" label="币种金额汇率"></el-table-column>
      <el-table-column
        prop="settleCountAmount"
        label="结算币种金额"
      ></el-table-column>
      <el-table-column prop="settleCurrency" label="结算币种"></el-table-column>
      <el-table-column label="结算状态">
        <template slot-scope="scope">
          <span v-if="scope.row.settlementStatus === 0">待结算</span>
          <span v-if="scope.row.settlementStatus === 1">待付款</span>
          <span v-if="scope.row.settlementStatus === 2">已结算</span>
          <div style="color: red">
            {{ scope.row.orderControversyStatus === 1 ? "(异常)" :  ""  }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="applySettleTime" label="申请日期">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.applySettleTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="settledTime" label="结算日期">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.settledTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="useSettleCurrency" label="是否用结算币别">
        <template slot-scope="scope">
          {{ scope.row.useSettleCurrency ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column prop="receivePayType" label="商家付款方式">
        <template slot-scope="scope">
          <span v-if="scope.row.receivePayType == 1">境外</span>
          <span v-if="scope.row.receivePayType == 2">境内</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="paymentCompletionOperatorName"
        label="付款完成人"
      ></el-table-column>
      <el-table-column width="240" label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.summaryFileInfos && scope.row.summaryFileInfos.length"
            @click="downloadMore(scope.row.summaryFileInfos)"
            type="text"
            size="small"
            >下载发票summary
          </el-button>
          <el-button
            v-if="scope.row && scope.row.settlementStatus === 1"
            @click="sendMail(scope.row)"
            type="text"
            size="small"
            >重新发送邮件</el-button
          >
          <el-button
            v-if="scope.row && scope.row.displayDownload"
            @click="downloadInvoice(scope.row)"
            type="text"
            size="small"
            >下载发票</el-button
          >
          <el-button
            v-if="scope.row && scope.row.displayDownload"
            @click="downloadInvoiceResult(scope.row)"
            type="text"
            size="small"
            >下载发票结果</el-button
          >
          <el-button
            v-if="scope.row && scope.row.displayUpdateSettleRate"
            @click="openUpdateSettleRateDialog(scope.row)"
            type="text"
            size="small"
            >修改汇率</el-button
          >
          <el-button
            v-if="scope.row && !scope.row.orderControversyStatus && scope.row.settlementStatus === 2"
            @click="identifiersRecordException(scope.row, 1)"
            type="text"
            size="small"
            >确认异常</el-button
          >
          <el-button
            v-if="scope.row && scope.row.orderControversyStatus === 1 && scope.row.settlementStatus === 2"
            @click="identifiersRecordException(scope.row, 0)"
            type="text"
            size="small"
            >取消异常</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <el-dialog
      append-to-body
      title="结算订单列表"
      :visible.sync="dialogVisible"
      width="900px"
    >
      <el-table :data="tableData2">
        <el-table-column
          prop="purchaseOrderNo"
          label="订单编号"
        ></el-table-column>
        <el-table-column
          prop="shipmentNo"
          label="Shipment NO."
        ></el-table-column>
        <el-table-column prop="settlementNo" label="原单号"></el-table-column>
        <el-table-column
          prop="settlementAmount"
          label="结算价"
        ></el-table-column>
        <el-table-column prop="shippedAt" label="完结日期">
          <template slot-scope="scope">
            {{ dateFormat(scope.row.shippedAt) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="paymentDescription"
          label="操作"
          v-if="settlementStatus === 1"
        >
          <template slot-scope="scope">
            <el-link type="primary" @click="rollbackItem(scope.row)"
              >回退</el-link
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="tr"
        @size-change="handleSizeChange2"
        @current-change="handleCurrentChange2"
        :current-page="queryForm2.pageNo"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="queryForm2.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total2"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog
      :title="$t('crm.batchSelectVendor')"
      :visible.sync="dialogVisibleBatchVendor"
      :close-on-click-modal="false"
      width="500px"
    >
      <p class="mb10">{{ $t("crm.batchEnterVendorTip") }}</p>
      <el-alert
        v-if="invalidVendorList.length > 0"
        :title="$t('crm.batchVendorNotExistTip')"
        class="mb10"
        type="error"
        effect="dark"
        :closable="false"
      >
        {{ invalidVendorList.join(", ") }}
      </el-alert>
      <el-checkbox class="mb10" v-model="inputVendorReverse">{{
        $t("crm.batchVendorReverseTip")
      }}</el-checkbox>
      <el-input type="textarea" :rows="14" v-model="inputVendorStr"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleBatchVendor = false">{{
          $t("common.cancel")
        }}</el-button>
        <el-button type="primary" @click="submitInputVendorStr">{{
          $t("common.ok")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改汇率"
      :visible.sync="updateSettleRateDialogStatus"
      width="500px"
    >
      <div>
        <el-form label-position="right" label-width="80px">
          <el-form-item label="结算单号">
            <el-input
              placeholder="请输入"
              :value="updateSettleRateDialogData.identifiersNo"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="结算汇率">
            <el-input
              placeholder="请输入"
              v-model="updateSettleRateDialogData.settleRate"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateSettleRateDialogStatus = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          :disabled="
            !updateSettleRateDialogData.identifiersNo ||
            !updateSettleRateDialogData.settleRate
          "
          @click="settleIdentifiersRateUpdate"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <FinalStatementPaper
      :data="finalStatementData"
      ref="FinalStatementPaper"
    ></FinalStatementPaper>
    <PayrollRequisitionPaper
      :data="payrollRequisitionData"
      ref="PayrollRequisitionPaper"
    ></PayrollRequisitionPaper>
  </div>
</template>

<script>
import { startOfDay, endOfDay, addDays } from "date-fns";
import utils from "@/utils/util";
import {
  downloadUrlFile,
  downloadFile,
  downloadMoreFile,
} from "@/utils/functions";
import {
  getVendorList,
  getPortalSettleList,
  batchSettledPortalSettle,
  getPortalSettleDetail,
  rollbackPortalSettle,
  exportPortalSettle,
  exportPortalSettleResult,
  getBusinessRegionList,
  resendEmail,
  batchResendEmail,
  identifiersExport,
  downloadInvoice,
  downloadInvoiceResult,
  settleIdentifiersRateUpdate,
  printIdentifiers,
  printIdentifiersDetail,
  identifiersRecordException
} from "./api";
import FinalStatementPaper from "./print/FinalStatementPaper.vue";
import PayrollRequisitionPaper from "./print/PayrollRequisitionPaper.vue";
import axios from 'axios'
import BrandSelect from "@/views/components/brandSelect";

export default {
  components: {
    FinalStatementPaper,
    PayrollRequisitionPaper,
    BrandSelect
  },
  data() {
    return {
      vendorList: [],
      vendorUnitMap: {},
      daterange: [],
      settledDateRange: [],
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          // 记录第一次点击的时间。
          this.firstDate = maxDate || minDate;
        },
        disabledDate: (time) => {
          // 超过前后180天禁用
          if (this.firstDate) {
            return (
              time >
                new Date(
                  this.firstDate.getTime() + 24 * 60 * 60 * 1000 * 180
                ) ||
              time <
                new Date(this.firstDate.getTime() - 24 * 60 * 60 * 1000 * 180)
            );
          }
          return false;
        },
      },
      queryForm: {
        vendorIds: [],
        settlementStatus: null,
        businessRegionId: null,
        paymentCompletionOperator: null,
        identifiersNos: null,
        controversyStatus: null,
        pageNo: 1,
        pageSize: 50,
      },
      tableData: [],
      businessRegionList: [], //业务运营区域
      total: 0,
      dialogVisible: false,
      settlementStatus: null,
      queryForm2: {
        identifiersNo: null,
        pageNo: 1,
        pageSize: 25,
      },
      tableData2: [],
      total2: 0,
      exporting: false,
      exporting2: false,
      exportFileName: "",
      exportFailed: false,
      exportFileName2: "",
      exportFailed2: false,
      selection: [],
      exportForm: {},
      invalidVendorList: [],
      inputVendorStr: "",
      inputVendorReverse: false,
      dialogVisibleBatchVendor: false,
      updateSettleRateDialogStatus: false,
      updateSettleRateDialogData: {
        identifiersNo: "",
        settleRate: "",
        vendorId: "",
      },
      finalStatementData: [],
      payrollRequisitionData: [],
      fullscreenLoading: false,
    };
  },
  // computed: {
  //   selection() {
  //     return this.tableData.filter(item => item.checked);
  //   },
  // },
  mounted() {
    getBusinessRegionList().then((res) => {
      let businessRegionList =
        res &&
        res.data &&
        (res.data.data || []).map((item) => {
          return {
            value: item.businessRegionId,
            label: item.businessRegionName,
          };
        });
      this.businessRegionList = businessRegionList;
    });
    getVendorList().then((res) => {
      if (res.data && res.data.data) {
        this.vendorList = res.data.data.map(item => {
          return {
            ...item,
            label: item.vendorName,
            value: item.vendorId
          }
        });
        const map = {};
        res.data.data.forEach((item) => {
          map[item.vendorId] = item.originalPriceUnit;
        });
        this.vendorUnitMap = map;
      }
    });
    this.setDefaultDate();
    this.getTableData();
    this.getShippedExportResult();
    this.getShippedExport2Result();
  },
  methods: {
    showBatchVendorForm() {
      this.invalidVendorList = [];
      this.inputVendorStr = "";
      this.inputVendorReverse = false;
      this.dialogVisibleBatchVendor = true;
    },
    submitInputVendorStr() {
      this.invalidVendorList = [];
      const idList = this.inputVendorStr
        .split("\n")
        .filter((item) => item.trim())
        .map((item) => item.trim());
      if (idList.length === 0) {
        this.$message(this.$t("common.plzInput") + this.$t("crm.vendorName"));
        return;
      }
      if (idList.length > 1000) {
        this.$message.error(this.$t("crm.batchVendorLimitTip"));
        return;
      }
      const vendorIds = [];
      idList.forEach((id) => {
        const flag = this.vendorList.some((item) => {
          if (item.vendorName.toLocaleLowerCase() === id.toLocaleLowerCase()) {
            vendorIds.push(item.vendorId);
            return true;
          }
          return false;
        });
        if (!flag) {
          this.invalidVendorList.push(id);
        }
      });
      if (this.invalidVendorList.length > 0) {
        return;
      }
      if (this.inputVendorReverse) {
        this.queryForm.vendorIds = this.vendorList
          .filter((item) => {
            return !vendorIds.includes(item.vendorId);
          })
          .map((item) => item.vendorId);
      } else {
        this.queryForm.vendorIds = vendorIds;
      }
      this.dialogVisibleBatchVendor = false;
    },
    handleSelectionChange(val) {
      this.selection = val;
    },
    batchResendEmail(row) {
      if (this.selection.length === 0) {
        this.$message("请选择一个单据");
        return;
      }
      let identifiersNos = this.selection.map(
        (item) => item.settlementIdentifiersNo
      );
      this.$confirm(`确认重新发送邮件吗`, "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        batchResendEmail(identifiersNos).then((res) => {
          if (res.data && res.data.success) {
            this.$message.success("重新发送成功");
          }
        });
      });
    },
    sendMail(row) {
      this.$confirm(`确认重新发送邮件吗`, "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        let { settlementIdentifiersNo } = row;
        resendEmail({ identifiersNo: settlementIdentifiersNo }).then((res) => {
          if (res.data && res.data.success) {
            this.$message.success("重新发送成功");
          }
        });
      });
    },
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.vendorIds = [];
      this.queryForm.settlementStatus = null;
      this.queryForm.businessRegionId = null;
      this.queryForm.paymentCompletionOperator = null;
      this.queryForm.identifiersNos = null;
      this.queryForm.controversyStatus = null;
      this.daterange = [];
      this.settledDateRange = [];
      this.queryForm.pageNo = 1;
      this.setDefaultDate();
      this.getTableData();
    },
    setDefaultDate() {
      this.daterange = [];
      this.settledDateRange = [];
      const startTime = startOfDay(addDays(new Date(), -30)).getTime();
      const endTime = endOfDay(new Date()).getTime();
      this.daterange = [startTime, endTime];
    },
    onDateBlur() {
      this.firstDate = null;
    },
    getTableData() {
      this.exportForm = {
        ...this.queryForm,
        startTime: (this.daterange && this.daterange[0]) || null,
        endTime: (this.daterange && this.daterange[1]) || null,
        settledStartTime:
          (this.settledDateRange && this.settledDateRange[0]) || null,
        settledEndTime:
          (this.settledDateRange && this.settledDateRange[1]) || null,
      };
      let identifiersNos = [];
      if (this.queryForm.identifiersNos) {
        identifiersNos = this.queryForm.identifiersNos.split("\n");
      }
      getPortalSettleList({
        ...this.queryForm,
        startTime: (this.daterange && this.daterange[0]) || null,
        endTime: (this.daterange && this.daterange[1]) || null,
        settledStartTime:
          (this.settledDateRange && this.settledDateRange[0]) || null,
        settledEndTime:
          (this.settledDateRange && this.settledDateRange[1]) || null,
        identifiersNos,
      }).then((res) => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = (res.data.data.list || []).map((item) => ({
            ...item,
            checked: false,
          }));
        }
      });
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    dateFormat(time) {
      if (!time) {
        return "";
      }
      return utils.dateFormat(new Date(time), "yyyy-MM-dd hh:mm:ss");
    },
    settlementDateFormat(time) {
      if (!time) {
        return "";
      }
      return utils.dateFormat(new Date(time), "yyMMdd");
    },
    batchSettled() {
      if (this.selection.length === 0) {
        return;
      }
      this.$confirm(`确认付款完成吗?`, "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          batchSettledPortalSettle(
            this.selection.map((item) => item.settlementIdentifiersNo)
          ).then((res) => {
            if (res.data.success) {
              this.$message.success(res.data.message || "操作成功");
              this.getTableData();
            } else {
              this.$message.error(res.data.message || "系统异常，请稍后再试");
            }
          });
        })
        .catch(() => {});
    },
    exportData() {
      if (this.selection.length === 0) {
        this.$message("请选择一个单据");
        return;
      }
      if (this.selection.length > 1) {
        this.$message("只能选择一个单据");
        return;
      }
      exportPortalSettle({
        identifiesNo: this.selection[0].settlementIdentifiersNo,
        vendorId: this.selection[0].vendorId,
      }).then((res) => {
        if (res.data.success) {
          this.getShippedExportResult();
        } else {
          this.$message.error(res.data.message || "系统异常，请稍后再试");
        }
      });
    },
    exportData2() {
      let identifiersNos = (this.selection || []).map(
        (item) => item.settlementIdentifiersNo
      );
      let params = {
        ...this.exportForm,
        identifiersNos,
      };
      identifiersExport(params).then((res) => {
        if (res.data.success) {
          this.getShippedExport2Result();
        } else {
          this.$message.error(res.data.message || "系统异常，请稍后再试");
        }
      });
    },
    showItem(row) {
      this.settlementStatus = row.settlementStatus;
      this.queryForm2.identifiersNo = row.settlementIdentifiersNo;
      this.queryForm2.pageNo = 1;
      this.tableData2 = [];
      this.total2 = 0;
      this.getTableData2();
      this.dialogVisible = true;
    },
    getTableData2() {
      getPortalSettleDetail(this.queryForm2).then((res) => {
        if (res.data && res.data.data) {
          this.total2 = res.data.data.total;
          this.tableData2 = res.data.data.list;
        }
      });
    },
    handleSizeChange2(pageSize) {
      this.queryForm2.pageSize = pageSize;
      this.getTableData2();
    },
    handleCurrentChange2(pageNo) {
      this.queryForm2.pageNo = pageNo;
      this.getTableData2();
    },
    rollbackItem(row) {
      this.$confirm(`确认回退吗?`, "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          rollbackPortalSettle([
            {
              shipmentNo: row.shipmentNo,
              identifiersNo: row.identifiersNo,
              settlementNo: row.settlementNo,
              orderType: row.orderType,
            },
          ]).then((res) => {
            if (res.data.success) {
              this.$message.success(res.data.message || "操作成功");
              this.getTableData2();
            } else {
              this.$message.error(res.data.message || "系统异常，请稍后再试");
            }
          });
        })
        .catch(() => {});
    },
    getShippedExportResult() {
      exportPortalSettleResult({
        taskCode: "portal_settlement_data",
      }).then((res) => {
        if (res.data.code === "0") {
          this.exporting = true;
          this.exportFileName = "";
          this.exportFailed = false;
          this.exportTimer = setTimeout(() => {
            this.getShippedExportResult();
          }, 2000);
        } else if (res.data.code === "1") {
          this.exporting = false;
          const data = JSON.parse(res.data.data);
          this.exportFileName = data.fileName;
          this.exportFileUrl = data.fileUrl;
          this.exportFailed = false;
          if (this.exportTimer) {
            clearTimeout(this.exportTimer);
          }
        } else if (res.data.code === "2") {
          this.exporting = false;
          this.exportFileName = "";
          this.exportFailed = true;
          if (this.exportTimer) {
            clearTimeout(this.exportTimer);
          }
        } else {
          this.exporting = false;
          this.exportFileName = "";
          this.exportFailed = false;
        }
      });
    },
    getShippedExport2Result() {
      exportPortalSettleResult({ taskCode: "identifiers_detail_export" }).then(
        (res) => {
          if (res.data.code === "0") {
            this.exporting2 = true;
            this.exportFileName2 = "";
            this.exportFailed2 = false;
            this.exportTimer2 = setTimeout(() => {
              this.getShippedExport2Result();
            }, 2000);
          } else if (res.data.code === "1") {
            this.exporting2 = false;
            const data = JSON.parse(res.data.data);
            this.exportFileName2 = data.fileName;
            this.exportFileUrl2 = data.fileUrl;
            this.exportFailed2 = false;
            if (this.exportTimer2) {
              clearTimeout(this.exportTimer2);
            }
          } else if (res.data.code === "2") {
            this.exporting2 = false;
            this.exportFileName2 = "";
            this.exportFailed2 = true;
            if (this.exportTimer2) {
              clearTimeout(this.exportTimer2);
            }
          } else {
            this.exporting2 = false;
            this.exportFileName2 = "";
            this.exportFailed2 = false;
          }
        }
      );
    },
    downloadExportResult() {
      downloadUrlFile(this.exportFileUrl);
    },
    downloadExportResult2() {
      downloadUrlFile(this.exportFileUrl2);
    },
    async downloadInvoice(row) {
      var res = await downloadInvoice({
        identifiesNo: row.settlementIdentifiersNo,
      });
      if (res.data.success) {
        this.$message.success(res.data.data || "操作成功！");
      } else {
        this.$message.error(res.data.message || "操作失败！");
      }
    },
    async downloadInvoiceResult(row) {
      var res = await downloadInvoiceResult(row.settlementIdentifiersNo);
      if (res.data.success && res.data.data) {
        downloadUrlFile(res.data.data);
      } else {
        this.$message.error(res.data.message || "操作失败！");
      }
    },
    async openUpdateSettleRateDialog({ settlementIdentifiersNo, vendorId }) {
      this.updateSettleRateDialogData.identifiersNo = settlementIdentifiersNo;
      this.updateSettleRateDialogData.vendorId = vendorId;
      this.updateSettleRateDialogData.settleRate = "";
      this.updateSettleRateDialogStatus = true;
    },
    async settleIdentifiersRateUpdate() {
      var res = await settleIdentifiersRateUpdate(
        this.updateSettleRateDialogData
      );
      if (res.data.success) {
        this.$message.success(res.data.data || "操作成功！");
        this.updateSettleRateDialogStatus = false;
        this.getTableData();
      } else {
        this.$message.error(res.data.message || "操作失败！");
      }
    },
    printPayrollRequisition() {
      this.fullscreenLoading = true;
      const body = {
        pageNo: 1,
        pageSize: this.selection.length,
        identifiersNos: this.selection.map(
          (item) => item.settlementIdentifiersNo
        ),
      };
      printIdentifiers(body).then((res) => {
        if (res.data.success) {
          this.finalStatementData = res.data.data;
          this.fullscreenLoading = true;
          this.$nextTick(() => {
            this.$refs.FinalStatementPaper.print();
            setTimeout(() => {
              this.fullscreenLoading = false;
            }, 1000);
          });
        } else {
          this.fullscreenLoading = false;
          this.$message.error(res.data.message || "系统异常，请稍后再试");
        }
      });
    },
    printFinalStatement() {
      this.fullscreenLoading = true;
      const body = this.selection.map((item) => item.settlementIdentifiersNo);
      printIdentifiersDetail(body).then((res) => {
        if (res.data.success) {
          this.payrollRequisitionData = res.data.data.data;
          this.$nextTick(() => {
            this.$refs.PayrollRequisitionPaper.print();
            setTimeout(() => {
              this.fullscreenLoading = false;
            }, 1000);
          });
        } else {
          this.fullscreenLoading = false;
          this.$message.error(res.data.message || "系统异常，请稍后再试");
        }
      });
    },
    downloadMore(list) {
      list.map(async (item) => {
        try{
          // const response = await axios.get(item.fileUrl, { responseType: "blob" });
           fetch(item.fileUrl).then(response => response.blob()).then(blob=>{
           downloadFile(blob,item.fileName)
           })
          console.log(response)
        } catch (error) {
          console.log(error)
        }
      });
    },
    identifiersRecordException(row,type){
      var _message = type === 1 ? "确认异常吗？" : "确认取消异常吗？"
      this.$confirm(_message, "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          identifiersRecordException(
            {
              settlementIdentifiersId: row.settlementIdentifiersId,
              controversyStatus: type
            },
          ).then((res) => {
            if (res.data.success) {
              this.$message.success(res.data.message || "操作成功");
              this.getTableData();
            } else {
              this.$message.error(res.data.message || "系统异常，请稍后再试");
            }
          });
        })
        .catch(() => {});
    },
    canSelect(row) {
      let {vendorControversyStatus} = row;
      let isCanSelect = vendorControversyStatus === 1 ? false : true;
      return isCanSelect
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.red {
  color: red;
}
.ml10 {
  margin-left: 10px;
}
.ml20 {
  margin-left: 20px;
}
.toolbar {
  display: flex;
  justify-content: space-between;
}
.store-wrap {
  max-height: 500px;
  overflow: auto;
}
.store-list {
  display: flex;
  margin-bottom: 2px;
  border: 1px solid #dcdfe6;
  border-radius: 5px;

  .store-name {
    flex: 0 0 auto;
    width: 150px;
    padding: 10px;
    border-right: 1px solid #dcdfe6;
  }
  .store-stocklocation-list {
    padding: 10px;
  }
}
.sl-group {
  display: flex;
  flex-wrap: wrap;

  .sl-item {
    margin-right: 10px;
    margin-top: 10px;
    padding: 0 5px;
    line-height: 30px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  .icon-close:hover {
    color: #409eff;
  }
}
.vendor-name {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
